import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    IconButton
} from "@vapor/react-material";
import React from "react";
import { Close } from "@mui/icons-material";
import { useTranslation } from "@onefront/react-sdk";

interface WarningDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
    cancel?: string;
    action?: string;
}

export const WarningDialog = ({ open, onClose, onConfirm, title, message, cancel, action }: WarningDialogProps) => {
    const { t } = useTranslation();
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle>
                {title}
                <IconButton color="primary" onClick={onClose}>
                    <Close />
                </IconButton>
            </DialogTitle>
            <Divider variant="alert" />
            <DialogContent>
                <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined">
                    {cancel ?? t("general.cancel")}
                </Button>
                <Button onClick={onConfirm} variant="contained" color="error">
                    {action ?? t("general.confirm")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
